import React, { useState } from 'react';

function ViewMore({ element }) {
  const [show, setShow] = useState(false);
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };
  return (
    <>
      <ul className="view-more">
        {element.actions &&
          element.actions.slice().reverse().slice(0, show ? element.actions.length : 2).map(action => {
            return (
              <li key={action.id} dangerouslySetInnerHTML={createMarkup(action.description)} />
            );
          })}
        <p className="see-more-button" onClick={() => setShow(!show)}>
          {element.actions.length > 2 ? (show ? 'See Less' : 'See More') : ''}
        </p>
      </ul>
    </>
  );
}
export default ViewMore;
